<form [formGroup]="form" class="container-fluid container-filter" autocomplete="off">
    <div class="animated fadeIn">

        <div class="row">
            <div class="col-md-12">
                <h4>Buscador de Puntos de Inspección</h4>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">
                    <a class="card-header-a" (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed"
                       aria-controls="collapseFiltros">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i> Filtros
                            <i *ngIf="isCollapsed" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsed" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>
                    <div class="card-body">
                        <!-- Ocultamos solo los campos, para que estén siempre visibles los botones "Buscar y Limpiar" -->
                        <div class="collapse group-filtros" id="collapseFiltros" [ngbCollapse]="isCollapsed">

                            <div class="row">

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpDescripcion">Descripción</label>
                                    <input formControlName="Descripcion" name="Descripcion" title="" maxlength="100"
                                           class="form-control" id="inpDescripcion" type="text" value="">

                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpCodigo">Código</label>
                                    <input formControlName="Codigo" name="Codigo" title="" maxlength="4"
                                           class="form-control" id="inpCodigo" type="text" value="">

                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpCodigo">Código TRACES</label>
                                    <input formControlName="CodigoTraces" name="CodigoTraces" title="" maxlength="20"
                                           class="form-control" id="inpCodigo" type="text" value="">

                                </div>

                            </div>

                            <div class="row">

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpPais">País</label>

                                    <ng-select appendTo="body"
                                               [items]="listPais"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdPais"
                                               loadingText="Cargando..."
                                               [loading]="(!listPais || listPais.length === 0)"
                                               notFoundText="País no encontrado"
                                               placeholder="-- Seleccione un País --"
                                               clearAllText="Eliminar selección"
                                               [ngClass]="displayFieldCssNgSelect('IdPais')"
                                               (change)="onSelectPais()">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                        </ng-template>
                                    </ng-select>
                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpProvincia">Provincia</label>

                                    <ng-select appendTo="body"
                                               [items]="listProvincia"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdProvincia"
                                               loadingText="Cargando..."
                                               [loading]="((!listProvincia || listProvincia.length === 0) && (form.value.IdPais == paisEspania))"
                                               notFoundText="Provincia no encontrada"
                                               placeholder="-- Seleccione una Provincia --"
                                               clearAllText="Eliminar selección"
                                               [ngClass]="displayFieldCssNgSelect('IdProvincia')"
                                               (change)="onSelectProvincia()">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                        </ng-template>
                                    </ng-select>

                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpMunicipio">Municipio</label>
                                    <ng-select appendTo="body"
                                               #municipio loadingText="Cargando..."
                                               [items]="listMunicipio"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdMunicipio"
                                               [loading]="((!listMunicipio || listMunicipio.length === 0) && (form.value.IdProvincia > 0))"
                                               notFoundText="Municipio no encontrado"
                                               placeholder="-- Seleccione un Municipio --"
                                               [ngClass]="displayFieldCssNgSelect('IdMunicipio')"
                                               clearAllText="Eliminar selección">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                        </ng-template>
                                    </ng-select>
                                </div>
                            </div>

                            <div class="row">

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpTipo">Tipo</label>

                                    <ng-select appendTo="body"
                                               loadingText="Cargando..."
                                               [items]="listTipoPuntoInspeccion"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdTipoPuntoInspeccion"
                                               [loading]="((!listTipoPuntoInspeccion || listTipoPuntoInspeccion.length === 0) && (form.value.IdPais == paisEspania))"
                                               notFoundText="Tipo PIF no encontrado. Seleccione España en el país"
                                               placeholder="-- Seleccione un Tipo de PIF --"
                                               [ngClass]="displayFieldCssNgSelect('IdTipoPuntoInspeccion')"
                                               clearAllText="Eliminar selección">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                        </ng-template>
                                    </ng-select>
                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpLocalidad">Localidad</label>
                                    <input formControlName="Localidad" name="Localidad" title="" maxlength="150"
                                           class="form-control" id="inpLocalidad" type="text" value="">

                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpCodigoPostal">Código Postal</label>
                                    <input class="form-control" formControlName="CodigoPostal" maxlength="15"
                                           inputStyleClass="form-control" id="inpCodPostal"
                                           value="">

                                </div>

                            </div>

                            <div class="row">

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpDescripcion">Activo</label>
                                    <p-selectButton class="selectButtonCust"
                                                    [options]="listSiNoTodos"
                                                    formControlName="Activo"
                                                    unselectable="true">
                                    </p-selectButton>
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpHabilitadoParaImportacion">Habilitado para importación</label>
                                    <p-selectButton class="selectButtonCust"
                                                    [options]="listSiNoTodos"
                                                    formControlName="HabilitadoParaImportacion"
                                                    unselectable="true">
                                    </p-selectButton>
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpHabilitadoParaExportacion">Habilitado para exportación</label>
                                    <p-selectButton class="selectButtonCust"
                                                    [options]="listSiNoTodos"
                                                    formControlName="HabilitadoParaExportacion"
                                                    unselectable="true">
                                    </p-selectButton>
                                </div>
                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpHabilitadoSanidadExterior">Habilitado para Higiene</label>
                                    <p-selectButton class="selectButtonCust"
                                                    [options]="listSiNoTodos"
                                                    formControlName="HabilitadoSanidadExterior"
                                                    unselectable="true">
                                    </p-selectButton>
                                </div>
                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpReasignableEx">Reasignable</label>
                                    <p-selectButton class="selectButtonCust"
                                                    [options]="listSiNoTodos"
                                                    formControlName="ReasignableEx"
                                                    unselectable="true">
                                    </p-selectButton>
                                </div>
                                
                            </div>

                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group-0 float-right">

                                    <div class="btn-group">
                                        <button name="btnSearch" class="btn btn-secondary btn-sm" type="submit" title="Realiza una búsqueda" (click)="onSearch($event)"><i class="fa fa-search"></i> Buscar</button>

                                    </div>

                                    <div class="btn-group">

                                        <button class="btn btn-secondary btn-sm" type="button" title="Limpia los filtros" (click)="onCleanForm($event)"><i class="fa fa-eraser"></i> Limpiar</button>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

</form>
